import { render, staticRenderFns } from "./HeaderRead.vue?vue&type=template&id=b0c747d2"
import script from "./HeaderRead.vue?vue&type=script&lang=js"
export * from "./HeaderRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports